import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b7ca2b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-config-title" }

import { t } from '@/plugins/i18n'
import { dayjs, ElMessage, FormInstance, ElRadioGroup, ElRadio } from 'element-plus'
import { ref, reactive, watch, computed } from 'vue'
import { syncOrder } from '@/apis/order'
import { confirmApiUnbind } from '@/util/useConfirm'
import CommonDialog from '@/components/common/CommonDialog.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props



const form = reactive({
  status: '1'
})

const formRef: any = ref<FormInstance>()
const submitLoading = ref(false)
const submit = () => {
  // console.log(form)
  emits('success', form)
  form.status = '1'
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false))),
    footer: true,
    onOk: submit,
    className: "address-config-common-dialog"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('一键设置追跡番号自動反映')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "address-form",
        ref: (_value, _refs) => {
          _refs['addressRef'] = _value
        },
        model: _unref(form),
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('设置当前页追迹番号反映'),
            prop: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElRadioGroup), {
                modelValue: _unref(form).status,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).status) = $event)),
                class: "ml_4",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElRadio), { label: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('开启')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ElRadio), { label: "0" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})